module.exports = __webpack_public_path__ + "static/media/learning-3.3c11879b.svg";